import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Button,
  Divider,
  Toolbar,
  Hidden,
  Typography,
  Link
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { APP_VERSION } from 'src/config';
import Logo from 'src/components/Logo';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default
  },
  toolbar: {
    height: 64
  },
  logo: {
    marginRight: theme.spacing(2)
  },
  link: {
    fontWeight: theme.typography.fontWeightMedium,
    '& + &': {
      marginLeft: theme.spacing(2)
    }
  },
  divider: {
    width: 1,
    height: 32,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  }
}));

function TopBar({ className, ...rest }) {
  const classes = useStyles();

  return (
    <AppBar
      className={clsx(classes.root, className)}
      color="default"
      {...rest}
    >
      <Toolbar className={classes.toolbar}>
        <RouterLink to="/">
          <Logo isDark={false} className={classes.logo} />
        {/* <h3>Mperito's Admin</h3> */}
        </RouterLink>
          <Typography
            variant="caption"
            color="textSecondary"
          >
            
          </Typography>
        <Box flexGrow={1} />
        {/* <Link
          className={classes.link}
          color="secondary"
          component={RouterLink}
          to="/signin"
          underline="none"
          variant="contained"
        >
          Sign In
        </Link> */}
        <Divider className={classes.divider} />
        <Button
          color="secondary"
          component={RouterLink}
          to="/signin"
          variant="contained"
          size="small"
        >
          Sign In
        </Button>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string
};

export default TopBar;
